import React from 'react';
import { isEmpty } from 'lodash';
import { toast } from 'react-toastify';

import { keyBy } from 'lodash';

import firebase from '../../firebase';
import useDocumentSubscription from '../hooks/useDocumentSubscription';
import useCollectionSubscription from '../hooks/useCollectionSubscription';
import AdminPage from '../hocs/AdminPage';
import { prefectures, } from '../../shared/config';
import TenantTags from '../TenantTags';

const db = firebase.firestore();
const tenantsRef = db.collection('tenants');
const tagsRef = db.collection('tags');

export default AdminPage(function AdminTenant (props) {
  const { match: { params: { tenantId } } } = props;
  const tenant = useDocumentSubscription(tenantsRef.doc(tenantId), [tenantId]);
  const tags = useCollectionSubscription(tagsRef.orderBy('createdAt'));
  const tagsById = keyBy(tags, 'id');
  const senders = useCollectionSubscription(tenantsRef.doc(tenantId).collection('senders').orderBy('createdAt'), [tenantId]);

  return tenant != null && (
    <div className="admin-sales">
      <div className="p-4 bg-white my-4">
        <div className="d-flex flex-column align-items-center mb-3">
          <h4>{tenant.name}</h4>
          <TenantTags tagIds={tenant.tagIds} tagsById={tagsById} className="mt-1 text-center" />
        </div>
        <div className="mt-4 overflow-scroll">
          {
            senders.length > 0 ? (
              <table className="table sticky-table">
                <thead className="thead-light text-center">
                  <tr className="text-nowrap">
                    <th style={{ minWidth: 200 }}>識別名</th>
                    <th style={{ minWidth: 200 }}>郵便番号</th>
                    <th style={{ minWidth: 120 }}>都道府県</th>
                    <th style={{ minWidth: 150 }}>市区郡町村</th>
                    <th style={{ minWidth: 150 }}>町・番地</th>
                    <th style={{ minWidth: 150 }}>マンション・ビル名</th>
                    <th style={{ minWidth: 200 }}>氏名</th>
                    <th style={{ minWidth: 200 }}>電話番号</th>
                    <th style={{ minWidth: 100 }}>デフォルト</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    senders.map((sender) => {
                      const { id, ref, code, postalCode, prefecture, city, address1, address2, name, phone, isDefault = false, } = sender;
                      const onCheckDefault = async ({ target: { checked }}) => {
                        const suffix = ({ true: 'に', false: 'を解除' })[checked];
                        if(!window.confirm(`本当にデフォルト${suffix}しますか？`)) return;

                        if(checked) {
                          await Promise.all(senders.filter(_ => _.isDefault).map(_ => _.ref.update({ isDefault: false })));
                        }
                        await sender.ref.update({ isDefault: checked });
                        toast.success(`デフォルト${suffix}しました`);
                      };

                      return (
                        <tr key={id}>
                          <td>
                            {code}
                          </td>
                          <td>
                            {postalCode}
                          </td>
                          <td>
                            {prefectures[prefecture]}
                          </td>
                          <td>
                            {city}
                          </td>
                          <td>
                            {address1}
                          </td>
                          <td>
                            {address2}
                          </td>
                          <td>
                            {name}
                          </td>
                          <td>
                            {phone}
                          </td>
                          <td>
                            {isDefault && 'デフォルト'}
                          </td>
                        </tr>
                      );
                    })
                  }
                </tbody>
              </table>
            ) : (
              <div>
                配送元は未登録です
              </div>
            )
          }
        </div>
      </div>
    </div>
  );
});

